const state = {
  isLoading: false,
  userInfo: {}, // 储存用户信息
  token: "",
  cartItemData: {}, // 储存选中购物车商品信息
  isShowLoginModel: false, // 相关操作未登录显示登录模态框
  auctionRecordItem: [] //储存列表信息, 用户跳转个人拍卖详情页做缓存
};
export default state;
